import { Box, CardContent } from "@mui/material";
import { Link } from "react-router-dom";
import LoginForm from "./LoginForm/LoginForm";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const LoginPage = () => {
  const { t } = useTranslation();

  const appConfig = useSelector((state) => state.app.appConfig);
  const primaryColor = useSelector((state) => state.app.primaryColor);

  return (
    <CardContent className="py-12 px-24">
      <>
        <Box className="flex flex-col items-center mt-5">
          <img
            src={appConfig?.assets?.imgs?.login}
            alt="logo"
            className="h-24"
          />
          <h3 style={{ color: primaryColor }} className="text-center">
            {t("LoginSentence")}
          </h3>
        </Box>

        <LoginForm />

        <p className="text-center mt-8">
          {t("ForgotPassword")}
          <Link to="/forgot-password">
            <span className="font-bold"> {t("RecoverPassword")} </span>
          </Link>
        </p>
      </>
    </CardContent>
  );
};

export default LoginPage;
